import * as generate from "nanoid/generate";

export const generateId = (size: number) => generate("1234567890abcdef", size);
export const generateBpmnId = () => {
  const alphabet = "abcdefghijklmnopkrstuvwxzABCDEFGHIJKLMNOPKRSTUVWXZ";
  const id = generate(alphabet, 3) + generate(`0123456789_${alphabet}`, 19);
  return id;
};
